import { Form, Steps } from "antd";
import React, { useEffect, useState } from "react";
import { get_estadospedidoventa } from "../../../actions";
import { parseDateTimeFormatFrontEnd } from "../../../helpers";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

export const PedidoVentaEstadosSteps = () => {
  const form = Form.useFormInstance();
  const [items, setItems] = useState([]);
  const estado = Form.useWatch("estado", form);
  const estadospedidoventa = Form.useWatch("estadospedidoventa", form);
  useEffect(() => {
    const OnLoadFormasPago = async () => {
      const datos = await get_estadospedidoventa();
      let itemsData = [];
      datos?.forEach((item) => {
        const rowData = estadospedidoventa?.filter(
          (e) => e.estado === item.value,
        )?.[0];
        const existe = !!rowData;
        let status = "wait";
        let icon = <ClockCircleOutlined />;
        if (existe) {
          if (item.value === estado) {
            status = "process";
            icon = <LoadingOutlined />;
          } else {
            status = "finish";
            icon = <CheckCircleOutlined />;
          }
        }
        itemsData.push({
          title: item?.label,
          description: existe
            ? parseDateTimeFormatFrontEnd(rowData?.fechahora)
            : "",
          status: status,
          icon: icon,
        });
      });
      setItems(itemsData);
    };
    OnLoadFormasPago();
  }, [estadospedidoventa, estado]);

  return (
    <>
      <Steps current={1} items={items} />
    </>
  );
};
